import * as React from 'react';

import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function DatePickerValue({ label, getValue, valueChange, views, datetime = false }) {
    const [value, setValue] = React.useState(valueChange ? valueChange : '');
    const [valueDateTime, setValueDateTime] = React.useState(dayjs('2022-04-17T15:30'));

    React.useEffect(() => {
        datetime ? setValueDateTime(valueChange) : setValue(valueChange);
    }, [valueChange]);

    const handleOnChange = (newValue) => {
        const formatDay = !datetime
            ? dayjs(newValue.$d).format('YYYYMMDD')
            : dayjs(newValue.$d).format('YYYYMMDDHHmmss');
        !datetime ? setValue(formatDay) : setValueDateTime(formatDay);
        getValue && getValue(formatDay);
    };
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} sx={{ width: '100%' }}>
            <DemoContainer components={['DatePicker', 'DatePicker']} sx={{ width: '100%' }}>
                {datetime ? (
                    <DatePicker
                        views={views}
                        defaultValue={dayjs(valueChange)}
                        label={label}
                        fullWidth
                        ampm={false}
                        // openTo="month"
                        // renderMonth={(month, _value, _dayPicker, monthName, year) => <div>{`${monthName} ${year}`}</div>}
                        // views={['year', 'month']}
                        // view={MonthPickerView}
                        // openTo="month"
                        format="DD/MM/YYYY HH:mm:ss"
                        value={dayjs(valueDateTime)}
                        onChange={(newValue) => handleOnChange(newValue)}
                    />
                ) : (
                    <DatePicker
                        views={views}
                        defaultValue={dayjs(valueChange)}
                        label={label}
                        fullWidth
                        // openTo="month"
                        // renderMonth={(month, _value, _dayPicker, monthName, year) => <div>{`${monthName} ${year}`}</div>}
                        // views={['year', 'month']}
                        // view={MonthPickerView}
                        // openTo="month"
                        format="DD/MM/YYYY"
                        value={dayjs(value)}
                        onChange={(newValue) => handleOnChange(newValue)}
                    />
                )}
            </DemoContainer>
        </LocalizationProvider>
    );
}
